/**
 * Auto-fills the reply composer with the recital type's submission template
 * when a user replies in a submission thread.
 *
 * Uses a two-stage delayed approach (150ms + 400ms) to overwrite the
 * flarum/mentions mention that gets injected into the composer. We set
 * the textarea value directly via DOM and dispatch an 'input' event
 * to keep Mithril's state in sync.
 *
 * ReplyComposer is lazy-loaded in Flarum 2 — we use string-based extend()
 * so the hook is applied when the module loads on demand.
 */
import { extend } from 'flarum/common/extend';
import { getRecitalTypeForDiscussion } from './recitalTypes';
export default function addSubmissionTemplate() {
  extend('flarum/forum/components/ReplyComposer', 'oninit', function () {
    var discussion = this.attrs.discussion;
    if (!discussion) return;
    var recitalType = getRecitalTypeForDiscussion(discussion);
    if (!recitalType) return;
    var template = recitalType.submission_template;
    if (!template) return;
    this._recitalTemplate = template;
    this.composer.fields.content(template);
    this.composer.body.attrs.originalContent = template;
  });
  extend('flarum/forum/components/ReplyComposer', 'oncreate', function () {
    if (!this._recitalTemplate) return;
    var template = this._recitalTemplate;
    var composer = this.composer;
    var applyTemplate = function () {
      try {
        if (!composer.editor || !composer.editor.el) return;
        composer.fields.content(template);
        composer.editor.el.value = template;
        composer.editor.el.dispatchEvent(new Event('input', {
          bubbles: true
        }));
        m.redraw();
      } catch (e) {
        // Ignore DOMException from setSelectionRange
      }
    };
    setTimeout(applyTemplate, 150);
    setTimeout(applyTemplate, 400);
  });
}